"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
let Toggle = class Toggle extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isToggleOn = false;
    }
    get classToggle() {
        return [
            this.isToggleOn ? 'bmfw-toggle-on' : 'bmfw-toggle-off',
            `bmfw-toggle--size_${this.size}`,
            this.disabled ? 'bmfw-toggle--disabled' : '',
            `bmfw-toggle--orientation_${this.orientation}`,
            this.isToggleOn ? `bmfw-toggle--accent_${this.accent}` : '',
        ];
    }
    changeValue() {
        if (this.value === 'on') {
            this.switchOn();
        }
        if (this.value === 'off') {
            this.switchOff();
        }
        //this.$emit('togglePress');
    }
    togglePress() {
        this.isToggleOn = !this.isToggleOn;
        this.$emit('changeToggle', this.isToggleOn);
    }
    switchOn() {
        this.isToggleOn = true;
        this.$emit('changeToggle', this.isToggleOn);
    }
    switchOff() {
        this.isToggleOn = false;
        this.$emit('changeToggle', this.isToggleOn);
    }
    mounted() {
        this.isToggleOn = (this.value === 'on') ? true : false;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'light' })
], Toggle.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'm' })
], Toggle.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false })
], Toggle.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'horizontal' })
], Toggle.prototype, "orientation", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'Label example' })
], Toggle.prototype, "labelLeft", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' })
], Toggle.prototype, "labelRight", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'primary' })
], Toggle.prototype, "accent", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'on' })
], Toggle.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false })
], Toggle.prototype, "labelFadesOnDisabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true })
], Toggle.prototype, "uiFadesOnDisabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value')
], Toggle.prototype, "changeValue", null);
Toggle = __decorate([
    (0, vue_property_decorator_1.Options)({})
], Toggle);
exports.default = Toggle;
